export default __webpack_public_path__ + "static/media/2.c9c830f0.jpg";